<div class="main-container">
  <kp-login-header [signup]="true"></kp-login-header>

  <form class="form-email" [formGroup]="form" (ngSubmit)="onSubmit(form.value)">
    <label [formGroup]="form">
      <span class="form-label">Email</span>
      <input
        type="email"
        class="email"
        placeholder="Enter your email address"
        required
        formControlName="email"
        name="email"
        id="email"
        data-test="emailInput"
        (change)="emailUpdated()"
        (input)="emailUpdated()"
        (blur)="emailUpdated()" />
    </label>
    <p class="error" *ngIf="hasError$ | async">
      <svg-icon src="/assets/icons/alert-circle.svg"></svg-icon>
      Must be a valid email address
    </p>
    <p class="error" *ngIf="signUpError">
      <svg-icon src="/assets/icons/alert-circle.svg"></svg-icon>
      <span>{{ errorMessage }}</span>
    </p>
    <button class="button button-pill button-email-continue" type="submit" [disabled]="!form?.valid">Continue</button>
  </form>
  <div class="separator"><span class="separator-copy">or</span></div>
  <h2 class="login-instructions-sso">Sign up with:</h2>
  <div class="button-container">
    <button
      type="button"
      class="button button-pill button-sso button-sso-google"
      [disabled]="loginDisabled"
      (click)="signUpWithGoogle(socialSso.Google)"
      aria-label="Sign up with Google">
      <svg-icon class="button-sso-logo" src="/assets/icons/logo-Google-superG.svg"></svg-icon>
    </button>
  </div>
  <p>Already have an account?</p>
  <a routerLink="/login" class="sign-in">Sign in</a>
</div>
